export const POPUP_EVENT = "app:popup";

export function showPopup(message, options = {}) {
  if (typeof window === "undefined") return;

  window.dispatchEvent(
    new CustomEvent(POPUP_EVENT, {
      detail: {
        title: options.title || "Aviso",
        message,
        type: options.type || "info",
      },
    })
  );
}
